import { render, staticRenderFns } from "./TaskConfirmCreateModal.vue?vue&type=template&id=b20a5218&"
import script from "./TaskConfirmCreateModal.vue?vue&type=script&lang=js&"
export * from "./TaskConfirmCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports